import numberUtils from './number.utils';
import dayjs from 'dayjs';
import baseConfig from '@config/base.config';
import uuidUtils from '@utils/uuid.utils';
/**
 * async/await 获取error
 * example: const [err, data] = await awaitWrap(fetchData())
 * @param {*} promise
 */
export function awaitWrap<Response = any, Error = any>(
    promise: Promise<any>
): Promise<[Error, Response]> {
    return promise
        .then(data => {
            return [null, data];
        })
        .catch(err => [err, null]) as any;
}

/**
 * 按对象属性升序排序
 * @params {key} 需要比较的key名字
 */
export function ascCompare(prop: string) {
    return function (m: { [x: string]: any }, n: { [x: string]: any }) {
        const a = m[prop];
        const b = n[prop];
        return a - b;
    };
}
/**
 * 对象属性降序排序
 * @params {key} 需要比较的key名字
 */
export function descCompare(prop: string) {
    return function (m: { [x: string]: any }, n: { [x: string]: any }) {
        const a = m[prop];
        const b = n[prop];
        return b - a;
    };
}

export function b64DecodeUnicode(str: string) {
    try {
        return decodeURIComponent(
            atob(str)
                .split('')
                .map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join('')
        );
    } catch (err) {
        return str;
    }
}

export function b64EncodeUnicode(str: string) {
    try {
        return btoa(
            encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
                return String.fromCharCode('0x' + p1);
            })
        );
    } catch (err) {
        return str;
    }
}
/**
 * 千分位
 * @param num
 * @param symbol
 * @returns
 */
export function toThousand(num: number, symbol?: string) {
    if (!num) {
        return num;
    }
    symbol = symbol || ',';
    //分割小数点
    var tempArr = num.toString().split('.');

    tempArr[0] = tempArr[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1' + symbol);
    return tempArr.join('.');
}
/**
 * 保留两位小数。没有小数补.00
 * @param num
 * @param flag  是否需要保留两位小数
 * @returns
 */
export function toDecimal2(num: number | string, flag: boolean = true) {
    if (!flag) {
        return num;
    }
    let result = typeof num === 'string' ? parseFloat(num) : num;
    if (isNaN(result)) {
        return false;
    }
    result = numberUtils.strip(result / 100);
    let s_x = result.toString(); //将数字转换为字符串

    let pos_decimal = s_x.indexOf('.'); //小数点的索引值

    // 当整数时，pos_decimal=-1 自动补0
    if (pos_decimal < 0) {
        pos_decimal = s_x.length;
        s_x += '.';
    }
    // 当数字的长度< 小数点索引+2时，补0
    while (s_x.length <= pos_decimal + 2) {
        s_x += '0';
    }
    return s_x;
}

/**
 * 根据curreny 判断 如果是USD单位 需要*100 变成美分计算价格
 * @param price
 * @param currency
 * @returns
 */
export function getPriceByCurrency(price: number, currency: string) {
    return currency?.toUpperCase() === 'USD' ? numberUtils.strip(price * 100) : price;
}

export function loadAsyncScript(
    src: string,
    callback = function () {},
    option = { attributes: Array }
) {
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', src);
    script.setAttribute('async', 'true');
    script.setAttribute('defer', 'true');
    option?.attributes &&
        Array.isArray(option?.attributes) &&
        option?.attributes?.map(item => {
            script.setAttribute(item.key, item.value);
        });
    head.appendChild(script);

    if (script.readyState) {
        // ie
        script.onreadystatechange = function () {
            var state = this.readyState;
            if (state === 'loaded' || state === 'complete') {
                callback();
            }
        };
    } else {
        script.onload = function () {
            callback();
        };
    }
}

export function toBoolean(val: string) {
    if (val === '') return val;
    return val === 'true' || val == '1';
}

export function imgLoaded(url: string): undefined | Promise<Buffer> {
    if (!url) {
        return undefined;
    }

    return new Promise(function (resolve, reject) {
        if (url.slice(0, 4) == 'data') {
            let img = new Image();
            img.onload = function () {
                resolve(img);
            };
            img.onerror = function () {
                reject('Image load error');
            };
            img.src = url;
            return;
        }
        let img = new Image();
        img.setAttribute('crossOrigin', 'Anonymous');
        img.onload = function () {
            resolve(img);
        };
        img.onerror = function () {
            reject('Image load error');
        };
        img.src = url;
    });
}

export function readAsArrayBuffer(url: string, callback?: <T>(args: T) => T) {
    return new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest();
        xhr.responseType = 'blob'; //设定返回数据类型为Blob
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                resolve(reader.result);
            };
            reader.readAsArrayBuffer(xhr.response); //xhr.response就是一个Blob，用FileReader读取
        };
        xhr.open('GET', url);
        xhr.send();
    });
}

export function scrollToErr(className: string) {
    let isError = document.getElementsByClassName(className);
    isError[0].scrollIntoView({
        // 滚动到指定节点
        // 值有start,center,end，nearest，当前显示在视图区域中间
        block: 'center',
        // 值有auto、instant,smooth，缓动动画（当前是慢速的）
        behavior: 'smooth'
    });
}

export function i18nTransfer(text: string, variables: any) {
    if (!text) return '';
    if (!variables) return text;
    const r = text.match(/{.*?}/gi);
    if (!r) return text;
    for (let i = 0; i < r.length; i++) {
        text = text.replace(r[i], variables[r[i].replace('{', '').replace('}', '')]);
    }
    return text;
}

export function getPublishType(pageInfo: { deviceType: any; versions: any; status: any }) {
    if (!pageInfo) return;
    let type = '';
    const { deviceType, versions, status } = pageInfo;
    const currentVersion = versions?.[0];
    const pcHasContent =
        !deviceType?.includes('PC') || currentVersion?.pcContent?.sections?.length >= 1;
    const spHasContent =
        !deviceType?.includes('MOBILE') || currentVersion?.mobileContent?.sections?.length >= 1;
    if (pcHasContent && spHasContent) {
        type = status === 'DRAFT' ? 'publishSetting' : 'publish';
    } else {
        let bothDevice = deviceType.length === 2;
        if (bothDevice && !pcHasContent && spHasContent) {
            type = 'publishNoPC';
        } else if (bothDevice && !spHasContent && pcHasContent) {
            type = 'publishNoSP';
        } else {
            type = 'publishNoContent';
        }
    }
    return type;
}

export function getFullDate(timestr: any, isMilliseconds: boolean = true) {
    const time = isMilliseconds ? new Date(Number(timestr)) : new Date(timestr);
    const YY = time.getFullYear();
    const MM = time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1;
    const DD = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
    const HH = time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
    const mm = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
    const ss = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds();
    return `${YY}/${MM}/${DD} ${HH}:${mm}:${ss}`;
}

/**
 * 获取明天的0点时间戳和后天23点59分59秒的时间戳
 * @param {*} key: start/end
 */
export function getTimestamp(key = 'start') {
    const days = key === 'start' ? 1 : 2;
    const formatString = `YYYY/MM/DD ${key === 'start' ? '00:00:00' : '23:59:59'}`;
    return dayjs(dayjs().add(days, 'day').format(formatString)).valueOf();
}

/**
 * 数组group
 * @returns {Object}: {a: [...], b: [...]}
 */
export function groupBy(array: Array, f: (arg0: any) => any) {
    let groups = {};
    array.forEach(function (o: any) {
        let group = f(o);
        groups[group] = groups[group] || [];
        groups[group].push(o);
    });
    // return Object.keys(groups).map(function(group) {
    //     return groups[group];
    // });
    return groups;
}

export const searchTree: any = function (
    tree: string | any[], // 要查的源数
    code: null | undefined, //要查找的值
    label = 'code', // 要查的key
    subTreekey = 'children' // 子tree的key
) {
    if (!Array.isArray(tree) || code === null || code === undefined) return null;

    for (let i = 0, max = tree.length; i < max; i++) {
        let item = tree[i];
        if (item[label] === code) {
            return item;
        } else if (item[subTreekey] && Array.isArray(item[subTreekey])) {
            let result = searchTree(item[subTreekey], code, label);
            if (result) return result;
        }
    }
    return null;
};

export const isMobile = () => {
    if (typeof window !== 'undefined') {
        if (
            window.navigator.userAgent.match(/Android/i) ||
            window.navigator.userAgent.match(/webOS/i) ||
            window.navigator.userAgent.match(/iPhone/i) ||
            window.navigator.userAgent.match(/iPad/i) ||
            window.navigator.userAgent.match(/iPod/i) ||
            window.navigator.userAgent.match(/BlackBerry/i) ||
            window.navigator.userAgent.match(/Windows Phone/i)
        ) {
            return true;
        } else {
            return false;
        }
    }
    return false;
};

export const suggest = () => {
    const hostname = window.location.hostname;
    const ptengine: any = window.ptengine;

    if (hostname.includes('.com')) {
        ptengine && ptengine.showEngagement('5f31a8c3-8143-421b-b025-bae8dcd9e680');
    } else {
        ptengine && ptengine.showEngagement('63646b6f-6253-466a-a933-7110e1c2b12b');
    }
};

export const generateHeatmapToken = function (sid: string, url: string) {
    const host: string = window.location.host;
    const area = baseConfig.AREA_CONF[host] || '4';
    const urlParam = sid + url + new Date().getTime();
    const key = uuidUtils.md5(urlParam, 32);
    return area + key;
};
